import {
  CellContext,
  ColumnHelper,
  DisplayColumnDef,
  RowData
} from "@tanstack/react-table";
import * as React from "react";

export type ActionColumnCellRenderer<TData extends RowData> = (info: CellContext<TData, unknown>) => React.ReactNode;
/**
 * This function returns a reusable formated column definition for actions to be used in Tanstack tables
 *
 * @param columnHelper
 * @param accessor
 * @param column
 * @returns column definition for actions
 */
export const actionColumn = <TData extends RowData>(
  columnHelper: ColumnHelper<TData>,
  cell: ActionColumnCellRenderer<TData>,
  column: Partial<Pick<DisplayColumnDef<TData>, "size">>
) => {
  return columnHelper.display({
    id: "actions",
    header: "Actions",
    cell: info => cell(info),
    enableSorting: false,
    size: column.size ? column.size : 150,
    enableResizing: false
  } as DisplayColumnDef<TData>);
};
